import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { ChartLegendPosition } from "src/app/shared/models/enums/ChartLegendPosition.enum";
import { SalesSummary } from "src/app/shared/models/SalesSummary.model";

@Component({
	selector: "app-order-type-meal-period-widget",
	templateUrl: "./order-type-meal-period-widget.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class OrderTypeMealPeriodWidgetComponent implements OnInit, OnChanges {
	@Input() checkDate: string;
	@Output() checkDateChange = new EventEmitter<string>();

	@Input() currentDaySalesSummary: SalesSummary;
	@Output() currentDaySalesSummaryChange = new EventEmitter<SalesSummary>();

	@Input() orderTypeMealPeriodViewSelected: string;
	@Output() orderTypeMealPeriodViewSelectedChange = new EventEmitter<string>();

	orderTypeChart = {
		data: undefined,
		options: undefined,
		type: "doughnut",
	};

	mealPeriodSummaryChart = {
		data: undefined,
		options: undefined,
		type: "doughnut",
	};

	activeChart = {
		options: undefined,
		data: undefined,
		type: "line",
	};

	constructor(public app: AppService, public venueService: OOVenueService) {}
	ngOnChanges(changes: SimpleChanges): void {
		if (changes.orderTypeMealPeriodViewSelected) {
			this.activeChart.data = undefined;
			this.assignChart(changes.orderTypeMealPeriodViewSelected.currentValue);
		}
		if (changes.currentDaySalesSummary) {
			this.buildCharts();
		}
	}

	ngOnInit(): void {
		this.buildCharts();
		this.assignChart("orderType");
	}

	async buildCharts() {
		this.mealPeriodSummaryChartBuild();
		this.orderTypeChartBuild();
	}

	async assignChart(chartView: string) {
		switch (chartView) {
			case "orderType":
				this.activeChart = { ...this.orderTypeChart };
				break;
			case "mealPeriod":
				console.log(`mealPeriod`);
				this.activeChart = { ...this.mealPeriodSummaryChart };
				break;
		}
	}

	async orderTypeChartBuild() {
		this.currentDaySalesSummary.orderTypeSummary?.forEach((ot, idx) => {
			ot.chartColor = this.app.references.chartColorsGoogle[idx];
		});
		const data = {
			labels: this.currentDaySalesSummary.orderTypeSummary?.map((orderType) => orderType.name),
			datasets: [
				{
					label: "Order Type",
					data: this.currentDaySalesSummary.orderTypeSummary?.map((orderType) => orderType.sales),
					fill: true,
					backgroundColor: this.currentDaySalesSummary.orderTypeSummary?.map((i) => i.chartColor),
				},
			],
		};
		this.orderTypeChart.data = data;
		this.orderTypeChart.options = this.app.references.chartConfig(ChartLegendPosition.NONE, false, false);
	}

	async mealPeriodSummaryChartBuild() {
		this.currentDaySalesSummary.mealPeriodSummary?.sort((a, b) => (a.id > b.id ? 1 : -1));
		this.currentDaySalesSummary.mealPeriodSummary?.forEach((mealPeriodSummary, idx) => {
			mealPeriodSummary.chartColor = this.app.references.chartColorsGoogle[idx];
		});

		const data = {
			labels: this.currentDaySalesSummary.mealPeriodSummary?.map((mealPeriodSummary) => mealPeriodSummary.name),
			datasets: [
				{
					label: "Meal Periods",
					data: this.currentDaySalesSummary.mealPeriodSummary?.map((mealPeriodSummary) => mealPeriodSummary.sales),
					fill: true,
					backgroundColor: this.currentDaySalesSummary.mealPeriodSummary?.map((i) => i.chartColor),
				},
			],
		};
		this.mealPeriodSummaryChart.data = data;
		console.log(this.mealPeriodSummaryChart.data);
		this.mealPeriodSummaryChart.options = this.app.references.chartConfig(ChartLegendPosition.NONE, false, false);
	}

	async mealPeriodDrillDown(mealPeriodId: number) {
		const mealPeriod = this.currentDaySalesSummary.mealPeriodSummary.find((mealPeriod) => mealPeriod.id === mealPeriodId);
		mealPeriod.intervals.forEach((interval, idx) => {
			interval.chartColor = this.app.references.chartColorsGoogle[idx];
		});

		const data = {
			labels: mealPeriod.intervals.map((interval) => interval.name),
			datasets: [
				{
					label: "Meal Periods",
					data: mealPeriod.intervals.map((mealPeriodSummary) => mealPeriodSummary.sales),
					fill: true,
					backgroundColor: mealPeriod.intervals.map((i) => i.chartColor),
				},
			],
		};
		this.mealPeriodSummaryChart.data = data;
		this.mealPeriodSummaryChart.options = this.app.references.chartConfig(ChartLegendPosition.NONE, false, false);
	}

	onDoughnutChartPieceSelect(event) {
		if (event.active && event.active.length > 0) {
			const idx = event.active[0].index;
			this.mealPeriodDrillDown(this.currentDaySalesSummary.mealPeriodSummary[idx].id);
		} else {
			this.mealPeriodSummaryChartBuild();
		}
	}
}
